export const API_HOST: string = process.env.REACT_APP_GRAPHQL_URL as string;
